import css from 'styled-jsx/css';
import { colors, fonts } from 'components/styles/variables';

export default css`
  .toggle-button {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    font-family: ${fonts.default};
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    text-transform: none;
    width: 100%;
    height: 48px;
    border-radius: 8px;
    background-color: ${colors.WHITE};
    border: 1px solid ${colors.G2};
  }
  .toggle-button:hover {
    background-color: ${colors.G1};
    color: ${colors.BLACK};
  }
  .toggled,
  .toggled:hover {
    background-color: ${colors.BLACK};
    border: 1px solid ${colors.G2};
    color: ${colors.WHITE};
  }
`;
